import React from 'react';
import {Route} from 'react-router';
import AsyncPage from './async';

export default [
  <Route
    key="/business/accessibility-statement"
    exact
    path="/business/accessibility-statement"
    component={AsyncPage}
  />,
];
